import { render, staticRenderFns } from "./crestViewStudentRegistration.vue?vue&type=template&id=d947266e&scoped=true&"
import script from "./crestViewStudentRegistration.vue?vue&type=script&lang=js&"
export * from "./crestViewStudentRegistration.vue?vue&type=script&lang=js&"
import style0 from "./crestViewStudentRegistration.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crestViewStudentRegistration.vue?vue&type=style&index=1&id=d947266e&scoped=true&lang=css&"
import style2 from "./crestViewStudentRegistration.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d947266e",
  null
  
)

export default component.exports